import angular from 'angular';

angular.module('cloudX').directive('cxTranslateBtn', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<button class="btn btn-default" ng-class="eClass" ng-click="showDialog(); $event.stopPropagation();" ng-disabled="disabled">' +
        '<i class="fa fa-language"></i>' +
        '</button>',
      scope: {
        key: '@',
        listid: '=?',
        fallback: '=?',
        eClass: '=?',
        disabled: '=?ngDisabled',
      },
      controller: [
        '$scope',
        'dialogsSvc',
        function($scope, dialogsSvc) {
          $scope.showDialog = function() {
            if (!$scope.key) return;
            if ($scope.listid || $scope.listid === 0) {
              dialogsSvc.translateListItem($scope.key, $scope.listid, $scope.fallback);
            } else {
              dialogsSvc.translateLabel($scope.key, $scope.fallback);
            }
          };
        },
      ],
    };
  },
]);
